import * as types from '../../action-types';
import { createBrokerFunding as initialState } from "../../initialState";

const createBrokerFunding = (state=initialState, action) => {
  switch (action.type) {
    case types.CREATE_BROKER_FUNDING_START:
      return {
        ...state,
        isLoading: true
      };
    case types.CREATE_BROKER_FUNDING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.CREATE_BROKER_FUNDING_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.CREATE_BROKER_FUNDING_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default createBrokerFunding;
